export const PUBLIC_PORTAL_PAGE_ROUTE = '/public/cbam-portal/:slug';
export const PUBLIC_PORTAL_WIDGET_ROUTE = '/public/cbam-widget/:slug';

const PUBLIC_PORTAL_PAGE_PREFIX = '/public/cbam-portal';
const PUBLIC_PORTAL_WIDGET_PREFIX = '/public/cbam-widget';

const publicPortalPrefix = (surface) =>
  surface === 'widget' ? PUBLIC_PORTAL_WIDGET_PREFIX : PUBLIC_PORTAL_PAGE_PREFIX;

export const buildPublicPortalPath = (slug, { surface = 'page' } = {}) =>
  `${publicPortalPrefix(surface)}/${encodeURIComponent(slug)}`;

export const buildPublicPortalUrl = (slug, options) =>
  `${window.location.origin}${buildPublicPortalPath(slug, options)}`;

const PUBLIC_PORTAL_PAGE_PATH_RE = /^\/public\/cbam-portal\/[^/]+\/?$/;
const PUBLIC_PORTAL_WIDGET_PATH_RE = /^\/public\/cbam-widget\/[^/]+\/?$/;

export const isPublicCatalogPath = (pathname) =>
  typeof pathname === 'string' && PUBLIC_PORTAL_PAGE_PATH_RE.test(pathname);

export const isPublicPortalWidgetPath = (pathname) =>
  typeof pathname === 'string' && PUBLIC_PORTAL_WIDGET_PATH_RE.test(pathname);
